type PlainTextSegment = {
  type: "plain";
  value: string;
};
type LinkSegment = {
  type: "link";
  href: string;
  label: string | null;
};
type ButtonSegment = {
  type: "button";
  href: string;
  label: string;
};

type Segment = PlainTextSegment | LinkSegment | ButtonSegment;

function getHandle(regex: RegExp, href: string, symbol = "@") {
  const handle = regex.exec(href)?.groups?.handle;

  if (handle) {
    return `${symbol}${handle}`;
  }

  return null;
}

function getCustomLabel(href: string) {
  const url = new URL(href);

  switch (url.hostname) {
    case "instagram.com":
    case "www.instagram.com": {
      return getHandle(/^https?:\/\/(www\.)?instagram\.com\/(?<handle>[A-Za-z0-9_.]+)\/?$/, href);
    }

    case "youtube.com":
    case "www.youtube.com": {
      return getHandle(/^https?:\/\/(www\.)?youtube\.com\/@(?<handle>[A-Za-z0-9_.]+)\/?$/, href);
    }

    case "bsky.app": {
      return getHandle(
        /^https?:\/\/(www\.)?bsky\.app\/profile\/(?<handle>[A-Za-z0-9_.]+)\/?$/,
        href,
      );
    }

    case "reddit.com":
    case "www.reddit.com": {
      return getHandle(
        /^https?:\/\/(www\.)?reddit\.com\/user\/(?<handle>[A-Za-z0-9_-]+)\/?$/,
        href,
        "u/",
      );
    }

    default: {
      return null;
    }
  }
}

export function parseSegments(input: string): Segment[] {
  const BUTTON_REGEX = /^\[(?<label>[^\]]+)\]\s+(?<url>https?:\/\/\S+)\s*$/;

  // First check if the line matches our button syntax.
  const buttonMatch = input.match(BUTTON_REGEX);
  if (buttonMatch && buttonMatch.groups?.label && buttonMatch.groups?.url) {
    return [{ type: "button", label: buttonMatch.groups.label, href: buttonMatch.groups.url }];
  }

  // Otherwise split into segments
  const URL_REGEX = /https?:\/\/[^\s<>)"]+[^\s<>)".,;:!?]/g;
  const segments: Segment[] = [];
  let lastIndex = 0;

  for (const match of input.matchAll(URL_REGEX)) {
    const { index } = match;

    if (index > lastIndex) {
      segments.push({ type: "plain", value: input.slice(lastIndex, index) });
    }

    const href = match[0];
    const handle = getCustomLabel(href);

    segments.push({ type: "link", label: handle, href });
    lastIndex = index + match[0].length;
  }

  if (lastIndex < input.length) {
    segments.push({ type: "plain", value: input.slice(lastIndex) });
  }

  return segments;
}
